'use strict';
document.addEventListener('click', (event) => {
  const menu = document.querySelector('.mm-mobile-menu');
  if (menu && menu.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const menu = document.querySelector('.mm-mobile-menu[open]');
    if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
  }
});

// This is the thin phrase ribbon below the hero, not the separate use-case carousel.
if (window.customElements && !window.customElements.get('mm-marquee')) {
  class ModMossMarquee extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-mm-marquee-track]');
      this.slides = Array.from(this.querySelectorAll('[data-mm-marquee-slide]'));
      this.previous = this.querySelector('[data-mm-marquee-previous]');
      this.next = this.querySelector('[data-mm-marquee-next]');
      this.status = this.querySelector('[data-mm-marquee-status]');
      if (!this.track || !this.slides.length || !this.previous || !this.next || !this.status) return;
      this.events = new AbortController();
      // Four desktop phrases need about 1140px; keep smaller tablets scrollable too.
      this.mobile = window.matchMedia('(max-width: 1200px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.goTo(this.index - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.index + 1), options);
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => this.updatePosition());
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || event.target !== this.track) return;
        const rtl = window.getComputedStyle(this.track).direction === 'rtl';
        let index;
        if (event.key === 'ArrowRight') index = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') index = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.goTo(index);
      }, options);
      this.mobile.addEventListener('change', () => this.updateMode(), options);
      window.addEventListener('resize', () => this.updatePosition(), options);
      this.updateMode();
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      window.cancelAnimationFrame(this.frame);
      this.events = null;
    }

    updateMode() {
      const carousel = this.mobile.matches && this.slides.length > 1;
      this.previous.hidden = this.next.hidden = this.status.hidden = !carousel;
      this.track.tabIndex = carousel ? 0 : -1;
      this.track.setAttribute('role', carousel ? 'group' : 'list');
      if (carousel) {
        this.setAttribute('aria-roledescription', 'carousel');
        this.track.setAttribute('aria-label', 'Phrases. Use arrow keys, Home or End to browse.');
      } else {
        this.removeAttribute('aria-roledescription');
        this.track.removeAttribute('aria-label');
        this.track.scrollTo({ left: 0, behavior: 'instant' });
      }
      this.slides.forEach((slide, index) => {
        slide.setAttribute('role', carousel ? 'group' : 'listitem');
        if (carousel) {
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', `${index + 1} of ${this.slides.length}: ${slide.textContent.trim()}`);
        } else {
          slide.removeAttribute('aria-roledescription');
          slide.removeAttribute('aria-label');
        }
      });
      this.updatePosition();
    }

    updatePosition() {
      if (!this.isConnected || !this.mobile.matches) return;
      const edge = window.getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
      const start = this.track.getBoundingClientRect()[edge];
      let nearest = Infinity;
      this.slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect()[edge] - start);
        if (distance < nearest) { nearest = distance; this.index = index; }
      });
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      const position = `${this.index + 1} of ${this.slides.length}`;
      if (this.status.textContent !== position) this.status.textContent = position;
    }

    goTo(index) {
      if (!this.mobile.matches) return;
      const slide = this.slides[Math.max(0, Math.min(this.slides.length - 1, index))];
      const edge = window.getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
      const offset = slide.getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
      this.track.scrollBy({ left: offset, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
    }
  }
  window.customElements.define('mm-marquee', ModMossMarquee);
}
